export const getTodayDateString = () => new Date().toLocaleDateString('en-GB');
